// extracted by mini-css-extract-plugin
module.exports = {"red":"group_red_1Ubsf"};